import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { postAxios } from "../Services/commonService";
import { API_POST_USERWISEPOSITION } from "../utils/api/ApiConstant";
import { DataTable } from "../Components";

const UserwisePosition = ({ rowData, handleShowHide }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(200);
  const { isLoading, data: userWisePosition } = useQuery({
    queryKey: ["userWisePosition", rowData?.ServerName],
    queryFn: async () => {
      const param = {
        server: rowData?.ServerName,
        ScriptToken: rowData?.ScriptToken,
      };

      const res = await postAxios({
        url: API_POST_USERWISEPOSITION,
        payload: param,
      });

      return res;
    },
    enabled: !!rowData?.ServerName,
  });

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRecordsperPage = (value) => {
    setRecordsPerPage(value);
  };

  const columns = [
    // { accessorKey: "ScriptToken", header: "ScriptToken" },
    // { accessorKey: "UserId", header: "UserId" },
    { accessorKey: "UserName", header: "UserName" },
    // { accessorKey: "ParentUserId", header: "ParentUserId" },
    { accessorKey: "ParentUser", header: "ParentUser" },
    { accessorKey: "ExchangeName", header: "Exchange" },
    // { accessorKey: "Description", header: "Description" },
    // { accessorKey: "LotSize", header: "LotSize" },
    {
      accessorKey: "Position",
      header: "Position",
      cell: ({ row, getValue }) => {
        return (
          <div
            style={{
              cursor: "pointer",
              color: getValue() === "BUY" ? "green" : "red",
            }}
          >
            {getValue()}
          </div>
        );
      },
    },
    { accessorKey: "BuyQty", header: "BuyQty" },
    { accessorKey: "SellQty", header: "SellQty" },
    {
      accessorKey: "OpenQuantity",
      header: "OpenQty",
      cell: ({ row, getValue }) => {
        return (
          <div
            style={{
              cursor: "pointer",
              color: Number(getValue()) > 0 ? "green" : "red",
            }}
          >
            {getValue()}
          </div>
        );
      },
    },
    { accessorKey: "BuyPrice", header: "BuyPrice" },
    { accessorKey: "SellPrice", header: "SellPrice" },
    { accessorKey: "OpenAvgRate", header: "AvgRate" },
    {
      accessorKey: "PositionDate",
      header: "PositionDate",
      cell: ({ getValue }) => {
        const rawDate = getValue();
        const date = new Date(rawDate);

        const options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
          // hour: "2-digit",
          // minute: "2-digit",
          // second: "2-digit",
          // hour12: true,
          // timeZone: "Asia/Kolkata",
        };

        return date.toLocaleString("en-IN", options);
      },
    },
    { accessorKey: "PositionDays", header: "PositionDays" },
    { accessorKey: "RealizedPL", header: "RealizedPL" },
    { accessorKey: "TradeMarginValue", header: "TradeValue" },
    { accessorKey: "CurrentMapPrice", header: "CMP" },
    { accessorKey: "ProfitLoss", header: "P&L" },
    { accessorKey: "ServerName", header: "Server" },
  ];

  const fetchData = () => {
    if (!userWisePosition) return { data: [], pages: 0 };

    const startIndex = (currentPage - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;

    return {
      data: userWisePosition.slice(startIndex, endIndex),
      pages: Math.ceil(userWisePosition.length / recordsPerPage),
    };
  };

  return (
    <>
      <DataTable
        columns={columns}
        // fetchData={fetchData}
        data={fetchData().data}
        pages={fetchData().pages}
        isLoading={isLoading}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onRecordsPerPageChange={handleRecordsperPage}
        recordsPerPage={recordsPerPage}
        isSearchable={false}
        isPagination={true}
        isPageSize={true}
        isIndexing={true}
      />
    </>
  );
};

export default UserwisePosition;
